// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
/* eslint-disable camelcase */

import { createAsyncAction } from 'typesafe-actions';
import { Note } from '../../../types/Model';

export interface DeleteOnlineCourseNoteRequestPayload {
  id: number;
  noteId: string;
}
export interface DeleteOnlineCourseNoteSuccessPayload {
  id: number;
  notes: Note[];
}

export interface DeleteOnlineCourseNoteFailPayload {
  error: Error;
}

const deleteOnlineCourseNoteActions = createAsyncAction(
  'elearning/DELETE_ONLINE_COURSE_NOTE_REQUEST',
  'elearning/DELETE_ONLINE_COURSE_NOTE_SUCCESS',
  'elearning/DELETE_ONLINE_COURSE_NOTE_FAIL'
)<DeleteOnlineCourseNoteRequestPayload, DeleteOnlineCourseNoteSuccessPayload, DeleteOnlineCourseNoteFailPayload>();

export { deleteOnlineCourseNoteActions as default};
